/*
 * @Description:支付
 * @Author: 山淑兰
 * @Date: 2020-01-05 23:27:34
 * @LastEditTime: 2020-04-28 17:35:31
 * @LastEditors: 山淑兰
 */
export class InitPayConfig {
  m: string = "";
  muid: number = 0;
}
export class Create_PayOrder {
  m: string = "";
  muid: number = 0;
  Orderid: string = "";
  PayType: number = 0;
  PayCode: string = "";
  IsMobile: boolean = false;
  IsWxClient: boolean = false;
}
export class IQueryOrder {
  m: string = "";
  orderid: string = "";
}
